export enum EmploymentType {
  FullTime = 'full_time',
  PartTime = 'part_time',
  Contract = 'contract',
  Internship = 'internship',
  Temporary = 'temporary',
  PerDiem = 'per_diem',
  Other = 'other'
}

export function getEmploymentTypeLabel(employmentType: EmploymentType): string {
  const labels: Record<EmploymentType, string> = {
    [EmploymentType.FullTime]: 'Full Time',
    [EmploymentType.PartTime]: 'Part Time',
    [EmploymentType.Contract]: 'Contract',
    [EmploymentType.Internship]: 'Internship',
    [EmploymentType.Temporary]: 'Temporary',
    [EmploymentType.PerDiem]: 'Per Diem',
    [EmploymentType.Other]: 'Other'
  };

  return labels[employmentType] || 'Unknown';
}

export function getEmploymentTypeOptions(): {
  value: EmploymentType;
  label: string;
}[] {
  return [
    {
      value: EmploymentType.FullTime,
      label: getEmploymentTypeLabel(EmploymentType.FullTime)
    },
    {
      value: EmploymentType.PartTime,
      label: getEmploymentTypeLabel(EmploymentType.PartTime)
    },
    {
      value: EmploymentType.Contract,
      label: getEmploymentTypeLabel(EmploymentType.Contract)
    },
    {
      value: EmploymentType.Internship,
      label: getEmploymentTypeLabel(EmploymentType.Internship)
    },
    {
      value: EmploymentType.Temporary,
      label: getEmploymentTypeLabel(EmploymentType.Temporary)
    },
    {
      value: EmploymentType.PerDiem,
      label: getEmploymentTypeLabel(EmploymentType.PerDiem)
    },
    {
      value: EmploymentType.Other,
      label: getEmploymentTypeLabel(EmploymentType.Other)
    }
  ];
}

export function validateEmploymentType(employmentType: EmploymentType): boolean {
  return Object.values(EmploymentType).includes(employmentType);
}
